import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";


import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
import AddOpeningComp from "./AddOpeningComp";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../../helpers/show_notification";
import preloader from "../../../../helpers/preloader";
import { convertToLowestUnit, ExportAvailableInCSVForReports, formatUnitsForReport, GetUpdatedDelivered,  } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import EnterQuantityModal from "../../../../components/EnterQuantityModal";
import { findEarliestExpiringBatches } from "../../../../helpers/batchWithdrawl";
import BatchWithdrawModal from "../../../../components/BatchWithdrawModal";
import ExpiryChangePopup from "../../../../components/ExpiryChangeModal";

const ViewInventory_Kitchen = (props) => {
  const { SearchBar } = Search;
  const is_manual_entry_allowed = localStorage.getItem("is_manual_entry_allowed") === "true";

  useEffect(() => {
    loadItems();
  }, []);

  const is_store = localStorage.getItem("is_store");
  const [allItems, setAllItems] = useState([]);
  const loadItems = async () => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "branchitems/getforbranch";
    const response = await postSubmitForm(url, {});

    if (response && response.status === 1) {
      preloader(false);
      setAllItems(response.data);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };


  const [transactionsModal, setTransactionsModal] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [selectedItem_Transactions, setSelectedItem_Transactions] = useState(
    []
  );
  const handleViewDetailsClick = async (row) => {
    let url =
      process.env.REACT_APP_BASEURL + "branchiteminventories/get_by_item_id";
    const response = await postSubmitForm(url, {
      item_id: row.item_id,
      inventory_type: "Store",
    });
    if (response && response.status === 1) {
      setSelectedItem_Transactions(response.data);
      setSelectedItem(row);

      setTransactionsModal(true);
    } else {
      showNotification(response.message, "Error");
    }
  };
  function editFormatter(cell, row) {
    return (
      <>
        <span className="text-info">
          <i
            className="mdi mdi-text-box-search font-size-15"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleViewDetailsClick(row);
            }}
          ></i>
        </span>{" "}
        <span  style={{ display: is_manual_entry_allowed ? 'inline' : 'none' }}>
            <i
              className="mdi mdi-cart-plus font-size-15"
              title="Add Opening Inventory"
              style={{ cursor: "pointer" }}
               hidden={!row.is_active}
              onClick={() => {
                setSelectedItemToAdd(row);
                setAddInventoryModal(!addInventoryModal);
              }}
            ></i>
          </span>
      </>
    );
  }
  const [selectedItemToAdd, setSelectedItemToAdd] = useState();
  const [addInventoryModal, setAddInventoryModal] = useState(false);

  const columns = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      csvExport: false,
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      // headerStyle: (colum, colIndex) => {
      //   return { width: "20%" };
      // },
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "threshold",
      text: props.t("Threshold"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return row.threshold+" "+row.unit_for_threshold;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Available"),
      sort: true,
      formatter:(cell,row)=>{
        let threshold = convertToLowestUnit(row?.unit_levels,[{unit:row?.unit_for_threshold,value:row?.threshold}]);
        let totalAvailable =   convertToLowestUnit(row?.unit_levels,row?.available)
 
      if (totalAvailable<=threshold) {
        return (
          <span
          style={{
            whiteSpace: "normal",
            display: "inline-block",
            maxWidth: "100%",
          }}
          className="font-size-12 badge-soft-danger badge badge-danger badge-pill mr-1 mb-1"
        >
          {formatUnitsForReport(row?.available,row?.unit_levels)}
        </span>
        );
      } else {
        return formatUnitsForReport(row.available,row.unit_levels);
      }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
   
    {
      text: props.t("Action"),
      formatter: editFormatter,
      csvExport: false,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const [selectedBatch, setSelectedBatch] = useState();
  const [withdrawModal, setWithdrawModal] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const handleWithdrawClicked = async (quantity) => {
    if (quantity.length <= 0) {
      showNotification("Please select atleast one unit ", "Warning")
      return
    }
    let convertedQuantity = GetUpdatedDelivered(quantity, selectedItem.unit_levels)
    let WithdrawQuantity = convertedQuantity?.map((item) => ({
      unit: item.unit,
      value: Number(item.value)
    }))
    const isInvalidTransfer = WithdrawQuantity.some(item => item.value === 0 && item.isChecked);

    if (isInvalidTransfer) {
      showNotification("Cannot withdraw products with 0 value and checked", "Warning");
      return;
    }
    setIsLoading(true)
    const object = {
      branchiteminventory_id: selectedBatch._id,
      quantity: WithdrawQuantity,
    };
    let url = process.env.REACT_APP_BASEURL + "branchiteminventories/withdraw";
    const response = await postSubmitForm(url, object);
    if (response && response.status === 1) {
      setIsLoading(false)
      showNotification(response.message, "Success");
      loadItems();
      setTransactionsModal(!transactionsModal);
      setWithdrawModal(!withdrawModal);
      return true
    } else {
      setIsLoading(false)
      showNotification(response.message, "Error");
      return false
    }
  };
  function checkValues(arr) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].value > 0) {
        return true;
      }
    }
    return false;
  }
  const [discardWasteModal, setDiscardWasteModal] = useState();
  const handleDiscardAsWaste = async (quantity) => {
    try {
     if(quantity.length<=0){
       showNotification("Please enter a valid quantity ","Warning")
       return
     }
     let convertedQuantity = GetUpdatedDelivered(quantity,selectedItem.unit_levels)
     const isInvalidTransfer = convertedQuantity.every(item => item.value == 0 );
     if (isInvalidTransfer) {
       showNotification("Cannot discard product with value 0 and checked", "Warning");
       return;
     }
     const object = {
       inventory_id: selectedBatch._id,
       quantity: convertedQuantity.map(({unit,value})=>({unit,value})),
     };
     setIsLoading(true)
     let url =  process.env.REACT_APP_BASEURL + "branchiteminventories/mark_wasted";
     const response = await postSubmitForm(url, object);
     if (response && response.status === 1) {
       showNotification(response.message, "Success");
       setTransactionsModal(!transactionsModal);
       setDiscardWasteModal(!discardWasteModal);
       loadItems();
       setSelectedBatch()
       return true
     } else {
       showNotification(response.message, "Error");
       return false
     }
    } catch (error) {
    //  console.log(error);
    } finally {
     setIsLoading(false)
    }
   };
   const [dateChangeModal, setDateChangeModal] = useState(false);
  const [selectedRowForDateChange, setSelectedRowForDateChange] = useState(null);
  const handleExpiryDateChange = async (newDate) => {
    try {
      if (!newDate) {
        showNotification("Please select a valid date", "Warning");
        return;
      }
      preloader(true);
      const url =
        process.env.REACT_APP_BASEURL +
        "storeiteminventories/update_expiry_date";
      const payload = {
        id: selectedRowForDateChange._id,
        batch: selectedRowForDateChange.batch,
        expiry_date: moment(newDate).format("YYYY-MM-DD"),
      };
      const response = await postSubmitForm(url, payload);
      if (response && response.status === 1) {
        showNotification("Expiry date updated successfully", "Success");
        handleViewDetailsClick(selectedItem);
        setDateChangeModal(false);
        setSelectedRowForDateChange(null);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification("Error updating expiry date", "Error");
    } finally {
      preloader(false);
    }
  };
  const columns_transaction = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
       return formatUnitsForReport(row.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "selling_price",
      text: props.t("Selling Price"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
   
    {
      text: props.t("Expiry Date"),
      sort: false,
      formatter: (cell, row) => {
      if (row.expiry_date) {
      return moment(row.expiry_date).format("DD/MM/YYYY HH:mm");
      } else {
      return (
                  <>
                    <span className="text-info d-flex align-items-center justify-content-center"
                      style={{cursor:"pointer"}}
                      onClick={() => {
                        setSelectedRowForDateChange(row);
                        setDateChangeModal(true);
                      }}
                    >
                      <i className="bx bxs-edit font-size-15" />
                    </span>
                  </>
                );
              }
            },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "",
      text: props.t("Entry Date"),
      sort: false,
      formatter: (cell, row) => {
        return moment(row.createdAt).format("DD/MM/YYYY HH:mm");
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
     {
          text: props.t("Withdraw"),
          formatter: (cell, row) => {
            // Finding earliest expiring batches
            const earliestBatches = findEarliestExpiringBatches(selectedItem_Transactions || []);
            // Checking if current row is in earliest batches
            const isEarliestBatch = earliestBatches.some(
              batch => batch._id === row._id
            );
            // Check if the batch has quantity
            const hasQuantity = row.quantity.some(q => q.value > 0);
            const isDisabled = row.expiry_date && !(isEarliestBatch && hasQuantity);
            return (
              <span className={`text-info ${isDisabled ? 'text-muted' : ''}`}>
                <i
                  className={`bx bx-download font-size-22 ${isDisabled ? 'text-secondary' : ''}`}
                  title="Withdraw"
                  style={{
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    opacity: isDisabled ? 0.5 : 1
                  }}
                  onClick={() => {
                    if (!isDisabled) {
                      setSelectedBatch(row);
                      setWithdrawModal(!withdrawModal);
                    }
                  }}
                ></i>
              </span>
            );
          },
          sort: false,
          headerStyle: (colum, colIndex) => {
            return { width: "9%" };
          },
        },
        {
          text: props.t("Mark Wasted"),
          formatter: (cell, row) => {
            return checkValues(row.quantity) ? (
    
              <span className="text-info">
                <i
                  className="bx bxs-trash font-size-22"
                  title="Move to Waste"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedBatch(row);
                    setDiscardWasteModal(!withdrawModal);
                  }}
                ></i>
              </span>
            ) : (
              <span className="text-info">Out of stock</span>
            );
          },
          sort: false,
          headerStyle: (colum, colIndex) => {
            return { width: "9%" };
          },
        },
  ];
  const pagination_options = {
    paginationSize: 5,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "All",
        value: selectedItem_Transactions && selectedItem_Transactions.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
    hideSizePerPage: true,
    ignoreSinglePage: true,
  };

  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);

  const handleDownload = async () => {
    const fileName = "item_inventory";
    const exportType = "xls";

    let data_to_export = allItems;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          Name: v.name,
          Category: v.category,
          SubCategory: v.sub_category,
          Available: ExportAvailableInCSVForReports(v.available),
          Threshold: v.threshold + " "+v.unit_for_threshold,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Item Inventory")}
            title={props.t("Inventory")}
            breadcrumbItem1={props.t("Items")}
            breadcrumbItem2={props.t("View Inventory")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Item Inventory")}
                    </CardTitle>
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allItems && allItems}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                  <Modal
                    size="xl"
                    // style={{
                    //   width: "940px",
                    //   maxWidth: "950px",
                    // }}
                    isOpen={transactionsModal}
                    toggle={() => setTransactionsModal(!transactionsModal)}
                  >
                    <ModalHeader
                      toggle={() => setTransactionsModal(!transactionsModal)}
                    >
                      Item Name: {selectedItem && selectedItem.name}
                    </ModalHeader>
                    <ModalBody>
                      {selectedItem && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          selectedItem_Transactions &&
                                          selectedItem_Transactions
                                        }
                                        columns={columns_transaction}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              pagination={paginationFactory(
                                                pagination_options
                                              )}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                  {/* withdraw modal start  */}
                                   <BatchWithdrawModal
                                     isOpen={withdrawModal}
                                     toggle={() => { setWithdrawModal(false); setSelectedBatch() }}
                                     onSubmit={handleWithdrawClicked}
                                     item={selectedItem}
                                     isLoading={isLoading}
                                     checkLimitFor={"batch"}
                                     selectedBatch={selectedBatch}
                                   />
                                   {/* withdraw modal end  */}

                  

                   {/* ---Waste Modal Start--- */}
                   <BatchWithdrawModal
                    isOpen={discardWasteModal}
                    toggle={()=>{setDiscardWasteModal(false);setSelectedBatch()}}
                    onSubmit={handleDiscardAsWaste}
                    item={selectedItem}
                    isLoading={isLoading}
                    checkLimitFor={"batch"}
                    selectedBatch={selectedBatch}
                  />
                 
                   {/* ---Waste Modal End--- */}

                  {/* add inventory modal starts */}
                  <Modal
                    size="lg"
                    style={{
                      width: "940px",
                      maxWidth: "950px",
                    }}
                    isOpen={addInventoryModal}
                    toggle={() => setAddInventoryModal(!addInventoryModal)}
                  >
                    <ModalHeader
                      toggle={() => setAddInventoryModal(!addInventoryModal)}
                    >
                      Add Inventory
                    </ModalHeader>
                    <ModalBody>
                      <AddOpeningComp
                        isRefreshData={true}
                        refreshData={loadItems}
                        selectedItem={selectedItemToAdd}
                        handleClosePopup={() =>
                          setAddInventoryModal(!addInventoryModal)
                        }
                      />
                    </ModalBody>
                  </Modal>

                  {/* add inventory modal ends */}

                   {/* ---Expiry Date Modal Start--- */}
                   <ExpiryChangePopup
                    isOpen={dateChangeModal}
                    toggle={() => {
                      setDateChangeModal(false);
                      setSelectedRowForDateChange(null);
                    }}
                    onSubmit={handleExpiryDateChange}
                    initialDate={selectedRowForDateChange?.expiry_date}
                    title="Update Expiry Date"
                  />
                  {/* ---Expiry Date Modal End--- */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ViewInventory_Kitchen))
);
